// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"147":"720aa2de","374":"8318db13","401":"f642474e","763":"9b017f2d","788":"ff328b1e"}[chunkId] + ".chunk.css";
};